import styled from 'styled-components';

export const Container = styled.div`
  img {
    @media only screen and (max-width: 768px) {
      width: 100%;
      height: auto;
    }
  }

  iframe {
    @media only screen and (max-width: 768px) {
      width: 100%;
      height: auto;
    }
  }
`;
